const firstNavImage = document.querySelectorAll(".navmenu-meganav-standard__image-container.navmenu-meganav-standard__image-first");
const lastNavImage = document.querySelectorAll(".navmenu-meganav-standard__image-container.navmenu-meganav-standard__image-last");

function checkWindowWidth() {
    return window.innerWidth <= 1360; //This is the value where the menus start to stack
}

function hideOrDisplayMenuImg() {
    [...firstNavImage, ...lastNavImage].forEach(img => {
        if(checkWindowWidth()){
            img.style.display = "none";
        } else img.style.display = "block";
    });
}

window.addEventListener("DOMContentLoaded",hideOrDisplayMenuImg);

window.addEventListener("resize", hideOrDisplayMenuImg);